/**
 * Level 2: Forest
 * 
 * Introduces moving platforms and more challenging terrain:
 * - Moving platforms (horizontal and vertical)
 * - More complex platform arrangements
 * - Multiple enemy encounters
 * 
 * @module configs/levels/Level02_Forest
 */

/** @type {import('../LevelTypes').LevelConfig} */
const Level02_Forest = {
    id: 2,
    name: 'Forest',
    subtitle: 'Into the Woods',
    description: 'Navigate through dense woodland with moving platforms.',
    
    worldWidth: 4000,
    worldHeight: 1200,
    playerStart: { x: 100, y: 700 },
    
    theme: {
        bgGradient: ['#2d5016', '#1a3009'],
        platformColor: 0x4a3728,
        accentColor: 0x6B8E23,
        particleColor: 0x90EE90
    },
    
    platforms: [
        { x: 0, y: 800, w: 600, h: 50 },
        { x: 500, y: 650, w: 200, h: 20 },
        { x: 800, y: 500, w: 150, h: 20 },
        { x: 1100, y: 800, w: 400, h: 50 },
        { x: 1400, y: 600, w: 200, h: 20 },
        { x: 1700, y: 450, w: 150, h: 20 },
        { x: 2000, y: 800, w: 500, h: 50 },
        { x: 2200, y: 550, w: 200, h: 20 },
        { x: 2600, y: 400, w: 150, h: 20 },
        { x: 2900, y: 800, w: 600, h: 50 },
        { x: 3500, y: 800, w: 500, h: 50 }
    ],
    
    movingPlatforms: [
        { x: 1000, y: 650, w: 150, h: 20, moveX: 200, speed: 0.002 },
        { x: 2500, y: 600, w: 150, h: 20, moveY: 150, speed: 0.003 }
    ],
    
    spikes: [
        { x: 1200, y: 800 },
        { x: 1250, y: 800 },
        { x: 2100, y: 800 },
        { x: 3000, y: 800 },
        { x: 3050, y: 800 }
    ],
    
    stars: [
        { x: 800, y: 450 },
        { x: 1700, y: 400 },
        { x: 2600, y: 350 },
        { x: 3200, y: 750 },
        { x: 3700, y: 750 }
    ],
    
    enemies: [
        { x: 1200, y: 750 },
        { x: 2100, y: 750 },
        { x: 2300, y: 500 },
        { x: 3300, y: 750 }
    ],
    
    door: { x: 3800, y: 650, w: 50, h: 300 },
    button: { x: 3400, y: 795 },
    box: { x: 2950, y: 750, floating: false },
    goal: { x: 3900, y: 700 },
    
    trampolines: [
        { x: 1900, y: 800, w: 80 }
    ],
    
    speedrunTargets: { gold: 40, silver: 55, bronze: 75 }
};

export default Level02_Forest;
